export default {
  alignment: 'Alignment',
};
